import type { FC, PropsWithChildren } from 'react';
import { FeatureFlag, useFeatureFlag } from '../hooks/useFeatureFlag';
import { logger } from '../lib/logger';
import { MultiChannelSocketConnectionContextProvider } from './MultiChannelSocketConnectionProvider';
import { SocketConnectionContextProvider } from './SocketConnectionProvider';

export const ConditionalSocketConnectionProvider: FC<PropsWithChildren> = ({ children }) => {
  const { variant } = useFeatureFlag(FeatureFlag.MultiChannelNotifications);
  const isMultiChannelSocketEnabled = variant === 'test';

  logger.debug('🏁 Socket provider selection:', {
    isMultiChannelEnabled: isMultiChannelSocketEnabled,
    usingProvider: isMultiChannelSocketEnabled ? 'MultiChannel' : 'Standard',
  });

  const SocketProvider = isMultiChannelSocketEnabled
    ? MultiChannelSocketConnectionContextProvider
    : SocketConnectionContextProvider;

  return <SocketProvider>{children}</SocketProvider>;
};
